// eslint-disable-next-line import/prefer-default-export
export const defaultSettings = { wordsCount: '10', roundTime: '10', lang: 'en', isSounds: 'true' };
